import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Cart from '../../../ECommerce/Cart/index';
import Catalog from '../../../ECommerce/Catalog/index';
import OrdersList from '../../../ECommerce/OrdersList/index';
import Payment from '../../../ECommerce/Payment/index';
import ProductEdit from '../../../ECommerce/ProductEdit/index';
import ProductPage from '../../../ECommerce/ProductPage/index';
import ProductsList from '../../../ECommerce/ProductsList/index';

export default () => (
  <Routes>
    <Route path="/e-commerce/cart" element={<Cart />} />
    <Route path="/e-commerce/catalog" element={<Catalog />} />
    <Route path="/e-commerce/orders_list" element={<OrdersList />} />
    <Route path="/e-commerce/payment" element={<Payment />} />
    <Route path="/e-commerce/product_edit" element={<ProductEdit />} />
    <Route path="/e-commerce/product_page" element={<ProductPage />} />
    <Route path="/e-commerce/products_list" element={<ProductsList />} />
  </Routes>
);
